import React, { useEffect } from "react";
import { CssBaseline } from '@material-ui/core';
import "./assets/css/app.css";
import RouteContainer from "./containers/RouteContainer";
import { Footer, Header, Page } from "./components";
import history from "./utils/history";
import { ScrollToTop } from "./components/ScrollToTop";
import useUrlEncryption from "./hooks/useUrlEncryption";
import { CustomMuiTheme } from "./components/shared/CustomMuiTheme";
import EnrollNowModal from "./components/shared/modal";
import { useModalContent } from "./hooks/useModal";
import { ModalContent } from "./store/enums/ModalContent";
import { Router } from "react-router-dom";

const App = () => {
  const { showError, isLoading } = useUrlEncryption();
  const { updateModalContent } = useModalContent();

  useEffect(() => {
    if (showError && !isLoading) {
      updateModalContent(ModalContent.PlanNotFound);
    }
  }, [showError, isLoading])
  

  return (
    <>
      <CustomMuiTheme>
        <CssBaseline />
        <Header />
        <main>
          {
            isLoading ? (
              <></>
            ) : (
              showError ? (
                <></>
              ) : (
                <Router history={history}>
                <Page>
                  <ScrollToTop>
                    <RouteContainer/>
                  </ScrollToTop>
                </Page>
                </Router>
              )
            )
          }
        </main>
        <EnrollNowModal showCloseButton={!showError}/>
        <Footer />
      </CustomMuiTheme>
    </>
  );
};

export default App;